import { addOverviewZoomControl } from '../../../services/GMap/useGMap'
import { useEffect, useContext } from 'react'
import { darkHMapStyles, defaultHMapStyles } from '../const/HMapStyle'
import { GlobalContext } from '../../../services/context/DataContext'

export const HEAT_MAP_RESTRICTION = {
  latLngBounds: {
    north: 80,
    south: -80,
    east: 180,
    west: -180
  },
  strictBounds: false
}

const useHMap = (ref, map, setMap) => {
  useEffect(() => addOverviewZoomControl(map), [map])
  // useUserGeolocation()
  const { latCoord, lngCoord } = useContext(GlobalContext)
  const [lat, setLat] = latCoord
  const [lng, setLng] = lngCoord
  const isDarkMode = localStorage.getItem('colorSelect') === 'Mystic Night'

  const setting = {
    zoom: 10,
    maxZoom: 16,
    minZoom: 3,
    center: { lat, lng },
    styles: isDarkMode ? darkHMapStyles : defaultHMapStyles,
    fullscreenControl: true,
    fullscreenControlOptions: {
      style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: window.google.maps.ControlPosition.RIGHT_BOTTOM
    },
    mapTypeControl: false,
    mapTypeControlOptions: {
      style: window.google.maps.MapTypeControlStyle.VERTICAL_BAR,
      position: window.google.maps.ControlPosition.BOTTOM_LEFT
    },
    zoomControl: true,
    zoomControlOptions: {
      style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: window.google.maps.ControlPosition.RIGHT_BOTTOM
    },
    scaleControl: true,
    streetViewControl: false,
    streetViewControlOptions: {
      style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: window.google.maps.ControlPosition.RIGHT_BOTTOM
    },
    keyboardShortcuts: false,
    restriction: HEAT_MAP_RESTRICTION
  }

  useEffect(() => {
    if (ref.current && !map) {
      const mapCentralization = JSON.parse(
        localStorage.getItem('mapCentralization')
      )
      const lastVisit = JSON.parse(localStorage.getItem('lastVisit'))

      const setInitialView = (latitude, longitude, zoom) => {
        setLat(latitude)
        setLng(longitude)

        setting.center = { lat: latitude, lng: longitude }
        setting.zoom = zoom

        setMap(new window.google.maps.Map(ref.current, setting))
      }

      const lastLatitude = Number(lastVisit?.lat)
      const lastLongitude = Number(lastVisit?.lng)
      const lastZoom = Number(lastVisit?.zoom)
      const hasLastVisit = Boolean(
        lastVisit &&
        Number.isFinite(lastLatitude) &&
        Number.isFinite(lastLongitude) &&
        Number.isFinite(lastZoom)
      )

      const [centralLatitude, centralLongitude] =
        mapCentralization?.location_coordinates?.split(',').map(Number) || []
      const centralZoom = Number(mapCentralization?.location_zoom)
      const hasCentralization =
        Number.isFinite(centralLatitude) && Number.isFinite(centralLongitude)

      if (hasLastVisit) {
        setInitialView(lastLatitude, lastLongitude, lastZoom || 5)
        return
      }

      if (hasCentralization) {
        setInitialView(centralLatitude, centralLongitude, centralZoom || 1)
        return
      }

      if (navigator.geolocation) {
        const showPosition = (position) => {
          setInitialView(
            position.coords.latitude,
            position.coords.longitude,
            5
          )
        }

        const failAlert = () => {
          const canadaLat = 63.1304
          const canadaLng = -96.3468
          setInitialView(canadaLat, canadaLng, 4)
        }

        const option = {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: Infinity
        }

        navigator.geolocation.getCurrentPosition(
          showPosition,
          failAlert,
          option
        )
      } else {
        setInitialView(63.1304, -96.3468, 4)
      }
    }
    // eslint-disable-next-line
  }, [ref, map])
}

export default useHMap
